<template>
<section class="position-relative d-flex align-items-center pt-5" id="about">
    <div class="container-xl pt-5">
        <div class="row">
            <div class="col-md-5 text-md-justify text-center text-white d-flex flex-column justify-content-center">
                <h1 class="text-primary font-weight-bold" style="font-size: 30px">O nas</h1>

                <div class="content" v-if="parent.data" v-html="parent.data.about.content"></div>
            </div>
            <div class="col-md-7 d-flex flex-column justify-content-center mb-md-0 mb-3">
                <img class="mw-100 mh-100" v-if="parent.data" :src="parent.data.about.url">
            </div>
        </div>
    </div>
</section>
</template>

<script>
    export default {
        data(){
            return {
                parent: this.$parent._data,
            }
        },
    }
</script>
